import createIcon from '../../createIcon';

/**
 * @component @name Male
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDExQzExLjQzIDExIDEzIDEyLjU3IDEzIDE0LjVDMTMgMTYuNDMgMTEuNDMgMTggOS41IDE4QzcuNTcgMTggNiAxNi40MyA2IDE0LjVDNiAxMi41NyA3LjU3IDExIDkuNSAxMVpNOS41IDlDNi40NiA5IDQgMTEuNDYgNCAxNC41QzQgMTcuNTQgNi40NiAyMCA5LjUgMjBDMTIuNTQgMjAgMTUgMTcuNTQgMTUgMTQuNUMxNSAxMy4zNCAxNC42NCAxMi4yNyAxNC4wMyAxMS4zOEwxOCA3LjQyVjEwSDIwVjRIMTRWNkgxNi41OEwxMi42MSA5Ljk3QzExLjczIDkuMzYgMTAuNjYgOSA5LjUgOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Male = createIcon('Male', [
  [
    'path',
    {
      d: 'M9.5 11C11.43 11 13 12.57 13 14.5C13 16.43 11.43 18 9.5 18C7.57 18 6 16.43 6 14.5C6 12.57 7.57 11 9.5 11ZM9.5 9C6.46 9 4 11.46 4 14.5C4 17.54 6.46 20 9.5 20C12.54 20 15 17.54 15 14.5C15 13.34 14.64 12.27 14.03 11.38L18 7.42V10H20V4H14V6H16.58L12.61 9.97C11.73 9.36 10.66 9 9.5 9Z',
      key: 'r3jdk3',
    },
  ],
]);

export default Male;
